import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { io, Socket } from 'socket.io-client';
import { map, mapTo, switchMap, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, from, fromEvent, interval, merge, Observable, of, Subject } from 'rxjs';

@Injectable(
)
export class BidStockService {
  auction_url: any = environment.API_AUCT_URL;
  url: any = environment.URL;
  api_url: any = environment.API_URL;
  public lastFiveBids$: BehaviorSubject<any> = new BehaviorSubject([{ isFrontEnd: true }]);
  public onlineBidAmount$: BehaviorSubject<string> = new BehaviorSubject('');
  public latestBidData$: BehaviorSubject<string> = new BehaviorSubject('');
  public bidsButtonValueUpdates$: BehaviorSubject<string> = new BehaviorSubject('');
  public messageData$: BehaviorSubject<string> = new BehaviorSubject('');
  public messageSound$: BehaviorSubject<string> = new BehaviorSubject('');
  public activeUser$: BehaviorSubject<string> = new BehaviorSubject('');
  public timerDuration$: BehaviorSubject<string> = new BehaviorSubject('');
  public onlineBidLast$: BehaviorSubject<string> = new BehaviorSubject('');
  public highLightFlag$: BehaviorSubject<string> = new BehaviorSubject('');
  public skipStatus$: BehaviorSubject<object> = new BehaviorSubject({});
  public skippedAuctionVehicles$: BehaviorSubject<string> = new BehaviorSubject('');
  public auctionDetails$: BehaviorSubject<string> = new BehaviorSubject('');
  public isUnsold$: BehaviorSubject<object> = new BehaviorSubject({});
  public isSold$: BehaviorSubject<object> = new BehaviorSubject({});
  public isUnderApproval$: BehaviorSubject<object> = new BehaviorSubject({});
  public timerOnlineAuction$: BehaviorSubject<object> = new BehaviorSubject({});
  public vehicleTimerOnlineAuction$: BehaviorSubject<object> = new BehaviorSubject({});
  public isTextMessage$: BehaviorSubject<object> = new BehaviorSubject({});
  public forcefullyRefresh$: BehaviorSubject<object> = new BehaviorSubject({});
  public isBothAudioTextMessage$: BehaviorSubject<object> = new BehaviorSubject({});
  public isAudioMessage$: BehaviorSubject<object> = new BehaviorSubject({});
  public pendingAuctionVehicle$: BehaviorSubject<string> = new BehaviorSubject('');
  public inventryData$: BehaviorSubject<string> = new BehaviorSubject('');
  public isCarApprovedData$: BehaviorSubject<string> = new BehaviorSubject('');
  public isProcessDone$: BehaviorSubject<string> = new BehaviorSubject('');
  public isSequenceChanged$: BehaviorSubject<string> = new BehaviorSubject('');
  public isProcessingData$: BehaviorSubject<string> = new BehaviorSubject('');
  public isPauseAuction$: BehaviorSubject<any> = new BehaviorSubject('');
  public receiveReservePriceStatus$: BehaviorSubject<any> = new BehaviorSubject('');
  public receiveMarketPriceStatus$: BehaviorSubject<any> = new BehaviorSubject('');
  public isRefreshForcce$: BehaviorSubject<string> = new BehaviorSubject('');
  public receiveFunctionalAudioMessage$: BehaviorSubject<object> = new BehaviorSubject({});
  public isAuctionVehicleReload$: BehaviorSubject<string> = new BehaviorSubject('');
  public isRefreshInventoryList$: BehaviorSubject<object> = new BehaviorSubject({});
  private socket: Socket;
  constructor(
    private http: HttpClient, ) {
        this.socket = io(environment.SOCKET_URL, { forceNew: true });
  }

//#region backend seperation for auction 

// SalerList(data: any) {
//   return this.http.post(this.url + 'user/list', data);
// }

deleteWatchList(data:any){
  const httpOptions = {
      headers: new HttpHeaders({}),body:data
  }
  return this.http.delete(this.auction_url + 'inventory/watchlistdelete',httpOptions);
}

 inventoryList(data: any) {
    return this.http.post(this.api_url + 'inventory/list', data);
  }


watchListAdd(data:any){
  return this.http.post(this.auction_url + 'inventory/watchlistadd',data);
}

getPendingAuctionVehicle(data: any) {
  return this.http.post(this.auction_url + 'auction/pending-auction-vehicles', data);
};

getFinishedAuctionVehicle(data: any) {
  return this.http.post(this.auction_url + 'auction/finished-auction-vehicles', data);
};

getSkippedAuctionVehicle(data: any) {
  return this.http.post(this.auction_url + 'auction/skipped-auction-vehicles', data);
};

auctionDetail(data:any){
  return this.http.post(this.url + 'auction/get-auction',data);
}

auctionListwithDate(data:any){
  return this.http.post(this.url + 'auction/active-auctions',data);
}

// updateuser(data: any) {
//   return this.http.patch(this.auction_url + 'user/update', data);
// }

//#endregion

  joinAuction(auctionId: any, inventoryId: any, userId: any, auctionStart: any, laneId:any) {
    this.socket.connect();
    this.socket.emit('joinAuction', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      userId,
      auctionStart,
      laneId
    });
  }

  joinAuctionvehicle(auctionId: any, inventoryId: any,  laneId:any) {
    this.socket.connect();
    this.socket.emit('joinAuction', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  }

  addBid(data: Object) {
    this.socket.connect();
    this.socket.emit('bidData', data);
  }

  public showHighLightEventSubscription = (auctionId: any, inventoryId: any,  laneId:any) => {
    this.socket.connect();
    this.socket.on('highlightEvent', (data: any) => {
      this.highLightFlag$.next(data);
    });
    return this.highLightFlag$.asObservable();
  };

  public emitshowHighlight(auctionId: any, inventoryId: any, flag,  laneId:any) {
    this.socket.connect();
    this.socket.emit('showHighlight', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      flag: flag,
      laneId
    });
  };

  public getUserCounts = (auctionId: any, inventoryId: any,) => {
    this.socket.connect();
    this.socket.on('userCount', (data: any) => {
      this.activeUser$.next(data);
    });
    return this.activeUser$.asObservable();
  };

  public getInventoryData = (auctionId: any, inventoryId: any) => {
    this.socket.connect();
    this.socket.on('inventryData', (data: any) => {
      this.inventryData$.next(data);
    });
    return this.inventryData$.asObservable();
  };

  public isProcessDone = () => {
    this.socket.connect();
    this.isProcessDone$.next('');
    this.socket.on('isProcessDone', (data: any) => {
      this.isProcessDone$.next(data);
    });
    return this.isProcessDone$.asObservable();
  };

  public isCarApproved = () => {
    this.socket.connect();
    this.socket.on('is-inventory-approved', (data: any) => {
      this.isCarApprovedData$.next(data);
    });
    return this.isCarApprovedData$.asObservable();
  };

  public emitIsCarApproved(auctionId: any, inventoryId: any,  laneId:any) {
    this.socket.emit('is-inventory-approved', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  };

  public isSequenceChanged = () => {
    this.socket.connect();
    this.socket.on('isSequenceChanged', (data: any) => {
      this.isSequenceChanged$.next(data);
    });
    return this.isSequenceChanged$.asObservable();
  };

  public isProcessing = () => {
    this.socket.connect();
    this.socket.on('isProcessing', (data: any) => {
      this.isProcessingData$.next(data);
    });
    return this.isProcessingData$.asObservable();
  };

  public pauseAuction = () => {
    this.socket.connect();
    this.socket.on('pauseAuction', (data: any) => {
      this.isPauseAuction$.next(data);
    });
    return this.isPauseAuction$.asObservable();
  };

  public receiveReservePriceStatus = () => {
    this.socket.connect();
    this.socket.on('receive-reserve-price-status', (data: any) => {
      this.receiveReservePriceStatus$.next(data);
    });
    return this.receiveReservePriceStatus$.asObservable();
  };
  public receiveMarketPriceStatus = () => {
    this.socket.connect();
    this.socket.on('receive-market-price-status', (data: any) => {
      this.receiveMarketPriceStatus$.next(data);
    });
    return this.receiveMarketPriceStatus$.asObservable();
  };

  public forceRefresh = () => {
    this.socket.connect();
    this.socket.on('forceRefresh', (data: any) => {
      this.isRefreshForcce$.next(data);
    });
    return this.isRefreshForcce$.asObservable();
  };

  public RevceiveFunctionalAudioMessageSubscription = () => {
    this.receiveFunctionalAudioMessage$.next({});
    this.socket.on('receiveFunctionalAudioMessage', (data: any) => {
      this.receiveFunctionalAudioMessage$.next(data);
    });
    return this.receiveFunctionalAudioMessage$.asObservable();
  };

  public unsubscribeReceiveFunctionalAudioMessage(): void {
    this.socket.removeListener('receiveFunctionalAudioMessage');
  }

  public getOnlineBidTime = (auctionId: any, inventoryId: any) => {
    this.socket.connect();
    this.socket.on('onlineBidSartTime', (data: any) => {
      this.onlineBidLast$.next(data);
    });
    return this.onlineBidLast$.asObservable();
  };

  private lastFiveBidsSubjects: Map<string, Subject<any>> = new Map();
  public lastFiveBidsSubscription(): Observable<any> {
    this.socket.connect();
    this.socket.on('last-five-bids', (data: any) => {
      this.lastFiveBids$.next(data);
    });
    return this.lastFiveBids$.asObservable();
    const auctionId = 'someAuctionId'; // Replace with actual auctionId
    if (!this.lastFiveBidsSubjects.has(auctionId)) {
      const subject = new Subject<any>();
      this.lastFiveBidsSubjects.set(auctionId, subject);
      // Listen to the socket once
      this.socket.on('last-five-bids', (data: any) => {
        if (data[0].auctionId === auctionId) {
          subject.next(data);
        }
      });
    }

    return this.lastFiveBidsSubjects.get(auctionId)!.asObservable();
  };

  public onlineBidAmountSubscription() {
    this.socket.connect();
    this.socket.on('online-bid-amount', (data: any) => {
      this.onlineBidAmount$.next(data);
    });
    return this.onlineBidAmount$.asObservable();
  };

  public emitLastFiveBides(auctionId: any, inventoryId: any,  laneId:any) {
    this.socket.emit('last-five-bids', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  };

  public getMessageSubscription() {
    this.socket.connect();
    this.messageData$.next('');
    this.socket.on('bidMessage', (data: any) => {
      this.messageData$.next(data);
    });
    return this.messageData$.asObservable();
  };

  public playSoundSubscription() {
    this.socket.connect();
    this.socket.on('beepEvent', (data: any) => {
      this.messageSound$.next(data);
    });
    return this.messageSound$.asObservable();
  };

  public closeBidsSubscription(auctionId: any, inventoryId: any,  laneId:any) {
    this.socket.connect();
    this.socket.emit('closeAuction', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  };

  public puseBidsSubscription = (auctionId: any, inventoryId: any, status: any,  laneId:any) => {
    this.socket.connect();
    this.socket.emit('puaseAuction', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      status: status,
      laneId
    });
  };

  public isAuctionVehicleReloadSubscription() {
    this.socket.connect();
    this.socket.on('refreshInventoryList', (data: any) => {
      this.isAuctionVehicleReload$.next(data);
    });
    return this.isAuctionVehicleReload$.asObservable();
  };

  public onlineTimerDurationSubscription() {
    this.socket.connect();
    this.socket.on('onlieTimerDuration', (data: any) => {
      this.timerDuration$.next(data);
    });
    return this.timerDuration$.asObservable();
  };

  public skipStatusSubscribe() {
    this.socket.connect();
    this.skipStatus$.next({});
    this.socket.on('skipStatus', (data: any) => {
      this.skipStatus$.next(data);
    });
    return this.skipStatus$.asObservable();
  };

  public auctionDetailsSubscription() {
    this.socket.connect();
    this.socket.on('auction-details', (data: any) => {
      this.auctionDetails$.next(data);
    });
    return this.auctionDetails$.asObservable();
  };

  public isUnSoldSubscription() {
    this.isUnsold$.next({});
    this.socket.connect();
    this.socket.on('isUnSold', (data: any) => {
      this.isUnsold$.next(data);
    });
    return this.isUnsold$.asObservable();
  };

  public isSoldSubscription() {
    this.isSold$.next({})
    this.socket.connect();
    this.socket.on('isSold', (data: any) => {
      this.isSold$.next(data);
    });
    return this.isSold$.asObservable();
  };

  public isUnderApprovalSubscribe() {
    this.socket.connect();
    this.isUnderApproval$.next({})
    this.socket.on('isUnderApproved', (data: any) => {
      this.isUnderApproval$.next(data);
    });
    return this.isUnderApproval$.asObservable();
  };

  public timerSubscription = () => {
    this.timerOnlineAuction$.next({});
    this.socket.on('timer', (data: any) => {
      this.timerOnlineAuction$.next(data);
    });
    return this.timerOnlineAuction$.asObservable();
  };

  public vehicleTimerSubscription = () => {
    this.vehicleTimerOnlineAuction$.next({});
    this.socket.on('count-up-timer', (data: any) => {
      this.vehicleTimerOnlineAuction$.next(data);
    });
    return this.vehicleTimerOnlineAuction$.asObservable();
  };

  public isTextMessageSubscription = () => {
    this.isTextMessage$.next({});
    this.socket.on('receiveTextMessage', (data: any) => {
      this.isTextMessage$.next(data);
    });
    return this.isTextMessage$.asObservable();
  };

  public isAudioMessageSubscription = () => {
    this.isAudioMessage$.next({});
    this.socket.on('receiveAudioMessage', (data: any) => {
      this.isAudioMessage$.next(data);
    });
    return this.isAudioMessage$.asObservable();
  };

  public isBothTextMessageSubscription = () => {
    this.isBothAudioTextMessage$.next({});
    this.socket.on('receiveBothMessages', (data: any) => {
      this.isBothAudioTextMessage$.next(data);
    });
    return this.isBothAudioTextMessage$.asObservable();
  };


  emitFunctionalMessage(type:any) {
    this.socket.emit('emitFunctionalMessage',type);
  };
  
  emitAuctionDetails(auctionId: any, inventoryId: any,  laneId:any) {
    this.socket.emit('auction-details', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  };

  public emitTimerInfo = (auctionId: any, inventoryId: any,  laneId:any) => {
    this.socket.emit('timer-info', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  };

  socketon() {
    this.socket.connect();
  }

  socketend(auctionId: any, userId: any,  laneId:any) {
    this.socket.removeAllListeners();
    this.socket.emit('disconnectUser', { auctionId, userId, laneId });
    this.socket.disconnect();
  }



  public callBids = (auctionId: any, inventoryId: any,  laneId:any) => {
    this.socket.connect();
    this.socket.emit('getBidData', {
      auctionId: auctionId,
      inventoryId: inventoryId,
      laneId
    });
  };

  public getSkipStatus = (auctionId: any, inventoryId: any) => {
    this.socket.connect();
    this.socket.on('skipStatus', (data: any) => {
      this.skipStatus$.next(data);
    });
    return this.skipStatus$.asObservable();
  };


  public getBids = (auctionId: any, inventoryId: any) => {
    this.socket.connect();
    this.socket.on('getData', (data: any) => {
      this.latestBidData$.next(data);
    });
    return this.latestBidData$.asObservable();
  };

  public bidsButtonValueUpdatesSubcription = () => {
    this.socket.connect();
    this.socket.on('lightBidsUpdated', (data: any) => {
      this.bidsButtonValueUpdates$.next(data);
    });
    return this.bidsButtonValueUpdates$.asObservable();
  };


  allvalueReset(){
    this.lastFiveBids$.next([{ isFrontEnd: true }]);
    this.latestBidData$.next('');
    this.messageData$.next('');
    this.messageSound$.next('');
    this.activeUser$.next('');
    this.timerDuration$.next('');
    this.onlineBidLast$.next('');
    this.highLightFlag$.next('');
    this.skipStatus$.next({});
    this.skippedAuctionVehicles$.next('');
    this.auctionDetails$.next('');
    this.isUnsold$.next({});
    this.isSold$.next({});
    this.isUnderApproval$.next({});
    this.timerOnlineAuction$.next({});
    this.isTextMessage$.next({});
    this.forcefullyRefresh$.next({});
    this.isBothAudioTextMessage$.next({});
    this.isAudioMessage$.next({});
    this.pendingAuctionVehicle$.next('');
    this.inventryData$.next('');
    this.isCarApprovedData$.next('');
    this.isProcessDone$.next('');
    this.isSequenceChanged$.next('');
    this.isProcessingData$.next('');
    this.isPauseAuction$.next('');
    this.isRefreshForcce$.next('');
    this.receiveFunctionalAudioMessage$.next({});
    this.isAuctionVehicleReload$.next('');
    this.isRefreshInventoryList$.next({});
  }

}
